<template>
  <div>
    <div class="allBox">
      <div class="usercenter_main mx-auto flex justify-between">
        <!-- 个人信息 -->
        <div class="personalInfo">
          <!-- 头像 -->
          <div class="user_center">
            <div class="user_avatar ">
              <img :src="portrait" alt="" class="user_pic">
            </div>
            <p class="user_level">{{ jibie }}</p>
            <p class="user_name">{{ name }}</p>
          </div>
          <div class="user_info">
            <!-- <p class="study">知识库</p> -->
            <!-- tab标签s -->
            <el-tabs tab-position="left" v-model="activeName1" class="bigTab" @tab-click="handleAllTabChange">
              <el-tab-pane disabled><span slot="label" class="study notallowed"><i class="kong"></i>知识文库</span>
              </el-tab-pane>
              <el-tab-pane label="文档管理" name="one">
                <el-tabs v-model="DocName" @tab-click="handleDocClick" class="doc">
                  <el-tab-pane label="我发布的文档" name="publish">
                    <div v-if="publishWDList.length>0">
                      <ul>
                        <li v-for="(item,index) in publishWDList" :key="index">
                          <img class="typeImg" :src="ure(item.file_infos&&item.file_infos.name)" alt="">
                          <div class="title">
                            {{ item.name }}
                            <a class="access" v-if="item.access==1">公开</a>
                            <a class="access" v-else-if="item.access==2">部分可见</a>
                            <a class="access" v-if="item.access==3">个人</a>
                          </div>
                          <p class="tl"><i class="time">发布时间：{{ item.add_time }}</i><i
                              class="looknum">浏览量：{{ item.look_num }}</i></p>
                          <el-button plain class="lookBtn" @click="toMyPublishDetail(item.id)">编辑</el-button>
                          <el-button plain class="delMPBtn" @click="toDeleteMP(item.id)">删除</el-button>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="activeWDList_total>pageWDSize"
                          @current-change="handleWDeCurrentChange"
                          :current-page="currentWDActivePage"
                          :page-size="pageWDSize"
                          layout=" prev, pager, next"
                          :total="activeWDList_total">
                      </el-pagination>
                    </div>
                    <div v-else class="kongImg"><img
                        src="https://qxystatic.qingxiaoyun.com/qxy/20200804/5f28f6ffb309b.png"/></div>
                  </el-tab-pane>
                  <el-tab-pane label="我评论的文档" name="recommed">
                    <div v-if="getPLList.length>0">
                      <ul>
                        <li v-for="(item,index) in getPLList" :key="index">
                          <img class="typeImg" :src="ure(item.file_type)" alt="">
                          <p class="title1">{{ item.name }}</p>
                          <p class="t2"><i class="time">发布时间：{{ item.add_time }}</i><i
                              class="looknum">浏览量：{{ item.look_num }}</i></p>
                          <el-button plain class="lookBtn" @click="toMyCommentDetail(item.id)">查看</el-button>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="activePLList_total>pagePLSize"
                          @current-change="handlePLCurrentChange"
                          :current-page="currentPLActivePage"
                          :page-size="pagePLSize"
                          layout=" prev, pager, next"
                          :total="activePLList_total">
                      </el-pagination>
                    </div>
                    <div v-else class="kongImg">
                      <img src="https://qxystatic.qingxiaoyun.com/qxy/20200804/5f28f6ffb309b.png"/>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane label="我的收藏" name="two">
                <el-tabs v-model="SCName" @tab-click="handleSCClick" class="doc">
                  <el-tab-pane label="文档收藏" name="docStore">
                    <div v-if="getSCList.length>0">
                      <ul>
                        <li v-for="(item,index) in getSCList" :key="index">
                          <img class="typeImg" :src="ure(item.file_type)" alt="">
                          <p class="title">{{ item.name }}</p>
                          <p class="tl"><i class="time">发布时间：{{ item.add_time }}</i><i
                              class="looknum">浏览量：{{ item.look_num }}</i></p>
                          <el-button plain class="lookBtn" @click="toDocDetail(item.content_id)">查看</el-button>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="activeWdSCList_total>pageWDSCSize"
                          @current-change="handleWDSCCurrentChange"
                          :current-page="currentWDSCActivePage"
                          :page-size="pageWDSCSize"
                          layout=" prev, pager, next"
                          :total="activeWdSCList_total">
                      </el-pagination>
                    </div>
                    <div v-else class="kongImg">
                      <img src="https://qxystatic.qingxiaoyun.com/qxy/20200804/5f28f6ffb309b.png"/>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane disabled><span slot="label" class="px notallowed">我的学习</span></el-tab-pane>
              <el-tab-pane label="我的培训" name="four">
                <el-tabs v-model="PXName" @tab-click="handlePXClick" class="doc">
                  <el-tab-pane label="培训计划列表" name="pxPlan">
                    <div v-if="pxDetailShow==false">
                      <ul>
                        <li v-for="(item,index) in pxList" :key="index">
                          <img :src="item.image" alt="" class="typeImg px_typeImg">
                          <p class="title px_title">{{ item.name }}</p>
                          <p class="tl px_t1"><i class="time">{{ item.synopsis }}</i></p>
                          <el-button plain class="lookBtn isOnTesk" v-if="item.complete=='0.00%'"
                                     @click="getToPXDetail(item.id)">开始任务
                          </el-button>
                          <el-button plain class="lookBtn finished" v-else-if="item.complete=='100.00%'">已完成</el-button>
                          <el-button plain class="lookBtn isOnTesk" v-else @click="getToPXDetail(item.id)">继续任务
                          </el-button>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="activePXList_total>pagePXSize"
                          @current-change="handlePXCurrentChange"
                          :current-page="currentPXActivePage"
                          :page-size="pagePXSize"
                          layout=" prev, pager, next"
                          :total="activePXList_total">
                      </el-pagination>
                    </div>
                    <div class="list" v-else>
                      <div class="top">
                        <p class="name">{{ teskDetail.name }}
                          <el-button type="success" plain class="still_btn">进行中</el-button>
                        </p>
                        <p class="tesk" v-if="teskDetail.time_status==0"><img
                            src="@/assets/images/naozhong.png"/><span>任务周期：<i>{{
                            teskDetail.create_time
                          }}</i><i>至</i><i>{{ teskDetail.end_time }}</i></span>
                        </p>
                        <p class="tesk" v-else>
                          <img
                            src="@/assets/images/naozhong.png"/><span>任务周期：<i>无限期</i></span>
                        </p>
                      </div>
                      <el-tabs v-model="teskName" @tab-click="handlePXItemClick" class="tabChild">
                        <el-tab-pane label="任务内容" name="teskDetailList">
                          <div style="height: 300px;margin-top:70x;">
                            <div>
                              <div v-if="pxDetailList.length>0">
                                <div
                                    v-for="(item, index) in pxDetailList"
                                    :key="index"
                                    class="traningItem"
                                >
                                  <div>
                                    <i class="el-icon-success green" v-if="item.is_complete==1"></i>
                                    <i class="el-icon-success" v-else></i>
                                    <span>{{ item.name }}</span>
                                  </div>
                                  <div class="wcBtn">
                                    <el-button v-if="item.is_complete==1">已完成</el-button>
                                    <el-button v-else class="stillBtn"
                                               @click="stillToStudy(item.content_id,teskDetail.id,item.sign)">
                                      <a v-if="item.sign=='tiku'">继续考试</a>
                                      <a v-else>继续学习</a>
                                    </el-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-tab-pane>
                        <el-tab-pane label="任务详情" name="teskItem">
                          <p v-html="teskDetail.content"></p>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <!-- 我的课程 -->
              <el-tab-pane label="我的课程" name="five">
                <el-tabs v-model="lessonType" @tab-click="handleLessonClick" class="doc lesson">
                  <el-tab-pane label="课程列表" name="lesson">
                    <div class="ss-center-box bg-white" v-if="lessonList.length>0">
                      <ul class="mx-25">
                        <li class="py-30  ss-user-item" v-for="(item,index) in lessonList" :key="index">
                          <div class="flex items-center relative">
                            <div class="w-200 h-116 ss-user-list-img">
                              <img class="object-cover" :src="item.content_info.image" alt="">
                            </div>
                            <div class="pl-20 ">
                              <div class="myLessonName" style="color:#333;">
                                {{ item.type == '0' ? item.content_info.name : item.content_info.title }}
                              </div>
                              <div class="mt-20">
                                <div class="hasStudy">已学习至：{{ item.study_name }}</div>
                              </div>
                            </div>
                            <div class="stillStudyBtn">
                              <div
                                  class="button1"
                                  style="border-radius:18px"
                                  v-if="item.content_info.is_delete=='1'"
                              >
                                已删除
                              </div>
                              <div
                                  :class="item.content_info.status=='1'?'button':'button1'"
                                  style="border-radius:18px"
                                  @click="toLessonDetail(item.content_info.id)"
                                  v-else
                              >
                                <a v-if="item.content_info.status=='1'">继续学习</a>
                                <a v-else>已下架</a>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="activeLessonList_total>lessonPageSize"
                          @current-change="handleLessonCurrentChange"
                          :current-page="currentLessonActivePage"
                          :page-size="lessonPageSize"
                          layout=" prev, pager, next"
                          :total="activeLessonList_total">
                      </el-pagination>
                    </div>
                    <div v-else class="kongImg">
                      <img src="https://qxystatic.qingxiaoyun.com/qxy/20200804/5f28f6ffb309b.png"/>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <!-- 我的考试的内容 -->
              <el-tab-pane label="我的考试" name="six">
                <el-tabs v-model="testName" @tab-click="handleKSClick"
                         :class="toTestDeatil==true?'doc test':'testDetail'">
                  <el-tab-pane label="考试列表" name="testList" v-if="toTestDeatil==true">
                    <div v-if="ksList.length>0">
                      <ul>
                        <li v-for="(item,index) in ksList" :key="index">
                          <p class="title">{{ item.name }}</p>
                          <p class="tl"><i class="time">总分：{{ item.total_score }}</i></p>
                          <el-button plain type="primary" class="lookBtn1" @click="toTest(item.store_id)">立即考试
                          </el-button>
                        </li>
                      </ul>
                      <el-pagination
                          background
                          v-if="ksList_total>ksPageSize"
                          @current-change="handleKSCurrentChange"
                          :current-page="currentKSActivePage"
                          :page-size="ksPageSize"
                          layout=" prev, pager, next"
                          :total="ksList_total">
                      </el-pagination>
                    </div>
                    <div v-else class="kongImg">
                      <img src="https://qxystatic.qingxiaoyun.com/qxy/20200804/5f28f6ffb309b.png"/>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane name="testdetail" v-else class="ksDetail">
                    <test></test>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <!-- 个人信息 -->
              <el-tab-pane disabled><span slot="label" class="mine notallowed">我的账号</span></el-tab-pane>
              <el-tab-pane label="个人信息" name="eight">
                <p class=activeNum>活跃度值：{{ active }}</p>
                <el-tabs v-model="userCenterTab" @tab-click="userCenterTabClick" class="doc userCount">
                  <el-tab-pane label="个人信息" name="usreInfo">
                    <div class="test0 test0-5">
                      <ul class="scrollbar">
                        <!-- 头像s -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">头像</span>
                            <el-upload
                                class="upload-demo"
                                :show-file-list="false"
                                :file-list="fileList"
                                :data="uploadData"
                                :headers="headers"
                                :on-success="successUpload"
                                :before-upload="handleBeforeUpload"
                                :on-change="handleFileChange"
                                :action="uploadActionUrl"
                                multiple>
                              <a-button>
                                <a-icon type="upload"/>
                                更换头像
                              </a-button>
                            </el-upload>
                            <a-avatar :src="userInfo.portrait" :size="60" class="yhxx_img absolute user_avatar"/>
                          </div>
                        </li>
                        <!-- 姓名s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">姓名</span>
                            <div class="yhxx_input">
                              <p type="text" v-html="userInfo.name" class="input_nicheng1"></p>
                            </div>
                          </div>
                        </li>
                        <!-- 联系方式s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">联系方式</span>
                            <div class="yhxx_input">
                              <input type="phone" v-model="userInfo.phone" class="input_nicheng1"
                                     placeholder="请输入您的联系方式">
                              <!-- 发送修改的手机号s -->
                              <el-popover
                                  v-if="updatePhone"
                                  placement="bottom"
                                  title="修改手机号"
                                  width="380"
                                  @hide="hidePopover"
                                  trigger="click">
                                <div>
                                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                                    <el-form-item prop="newYZMPhone">
                                      <el-input v-model="ruleForm.newYZMPhone" placeholder="请输入新的手机号"></el-input>
                                    </el-form-item>
                                  </el-form>
                                  <el-input v-model="newYZMInput" placeholder="请输入验证码">
                                    <div slot="suffix" class="yzmBox">
                                      <span v-show="show" @click="getCode">发送验证码</span>
                                      <span v-show="!show" class="count">{{ count }} s</span>
                                    </div>
                                  </el-input>
                                  <el-button type="primary" @click="sureUploadPhone">确认修改</el-button>
                                </div>
                                <a class="fixed" slot="reference">修改</a>
                              </el-popover>
                              <!-- 发送修改的手机号e -->

                              <!-- 发送之前验证登录的手机号s -->
                              <el-popover
                                  v-else
                                  placement="bottom"
                                  title="修改手机号"
                                  width="380"
                                  @hide="hidePopover"
                                  trigger="click">
                                <div>
                                  <p class="tipsName">发送短信到{{ userInfo.phone }}验证后修改</p>
                                  <el-input v-model="newYZMInput" placeholder="请输入验证码">
                                    <div slot="suffix" class="yzmBox">
                                      <span v-show="show" @click="getBeforeCode(userInfo.phone,1)">发送验证码</span>
                                      <span v-show="!show" class="count">{{ count }} s</span>
                                    </div>
                                  </el-input>
                                  <el-button type="primary" @click="beforePhone">确认</el-button>
                                </div>
                                <a class="fixed" slot="reference">修改</a>
                              </el-popover>
                              <!-- 发送之前验证登录的手机号e -->
                            </div>
                          </div>
                        </li>
                        <!-- 账号s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">账号</span>
                            <div class="yhxx_input">
                              <p v-html="userInfo.account" class="input_nicheng1"></p>
                            </div>
                          </div>
                        </li>
                        <!-- 登录密码s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">登录密码</span>
                            <div class="yhxx_input">
                              <p class="input_nicheng1 password">******</p>
                              <!-- 发送之前验证登录的密码s -->
                              <el-popover
                                  placement="bottom"
                                  title="修改密码"
                                  width="380"
                                  @hide="hidePopover"
                                  trigger="click">
                                <div>
                                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                                    <el-form-item prop="newYZMPWD">
                                      <el-input v-model="ruleForm.newYZMPWD" placeholder="请输入新的密码"></el-input>
                                    </el-form-item>
                                  </el-form>
                                  <el-input v-model="newYZMInput" placeholder="请输入验证码">
                                    <div slot="suffix" class="yzmBox">
                                      <span v-show="pwdshow" @click="getBeforeCode(userInfo.phone,2)">发送验证码</span>
                                      <span v-show="!pwdshow" class="count">{{ count1 }} s</span>
                                    </div>
                                  </el-input>
                                  <el-button type="primary" @click="sureUploadPWD">确认修改</el-button>
                                </div>
                                <a class="fixed" slot="reference">修改</a>
                              </el-popover>
                              <!-- 发送之前验证登录的手机号e -->
                            </div>
                          </div>
                        </li>
                        <!-- 性别s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">性别</span>
                            <div class="yhxx_input">
                              <p v-html="userInfo.sex" class="input_nicheng1" placeholder="请输入您的联系性别"></p>
                            </div>
                          </div>
                        </li>
                        <!-- 所属分组s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">所属分组</span>
                            <div class="yhxx_input">
                              <p type="phone" v-html="userInfo.departments_name" class="input_nicheng1"></p>
                            </div>
                          </div>
                        </li>
                        <!-- 职务s  -->
                        <li>
                          <div class="yhxx_div">
                            <span class="yhxx_name">职务</span>
                            <div class="yhxx_input">
                              <p v-html="userInfo.position" class="input_nicheng1"></p>
                            </div>
                          </div>
                        </li>
                        <!--用户自定义-->
                        <li v-for="(item,index) in custom_fields" :key="index">
                          <div class="yhxx_div">
                            <span class="yhxx_name">{{ item.title }}</span>
                            <div class="yhxx_input">
                              <p v-html="item.value" class="input_nicheng1"></p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <a-button class="yhxx_sure" @click="sureChangeUserInfo">确认修改</a-button>
                  </el-tab-pane>
                  <el-tab-pane label="活跃度" name="activeInfo">
                    <el-table
                        :data="activeTableList"
                        stripe
                        style="width: 100%">
                      <el-table-column
                          prop="remarks"
                          label="来源"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="number"
                          label="数值"
                      >
                      </el-table-column>
                      <el-table-column
                          prop="created_at"
                          label="时间"
                          width="200"
                      >
                      </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        v-if="activeTableList_total>pageSize"
                        @current-change="handleActiveCurrentChange"
                        :current-page="currentActivePage"
                        :page-size="pageSize"
                        layout=" prev, pager, next"
                        :total="activeTableList_total">
                    </el-pagination>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
            </el-tabs>
            <!-- tab标签e -->
          </div>
        </div>

        <!-- 右侧内容s -->
        <div class="rightSideList mt-25">

          <!-- 右侧内容s -->
        </div>
      </div>
      <el-dialog
          :visible.sync="dialogVisible">
        <img :src="ewCode" class="ewCode"/>
        <span class="toSM">扫码进入H5端考试</span>
      </el-dialog>
      <!-- <img src="@/assets/images/lesson4.png" class="ewCode" style="position: fixed;z-index: 10000;top: 50%;left: 50%;"/> -->
      <!-- <img :src="ewCode" class="ewCode" v-show="ewCode"/> -->
    </div>
  </div>
</template>

<script>
import {localStorageCache} from '@/assets/js/utils'
import test from '@/components/test'

export default {
  props: {
    pic: {
      type: String,
    }
  },
  components: {
    test
  },
  data() {
    return {
      headers: {token: '', dataType: "json"},//token
      activeName1: 'one',
      DocName: 'publish',// 文档高亮
      lessonType: 'lesson',//课程高亮
      testName: 'testList',// 考试的名字
      SCName: 'docStore',// 收藏高亮
      PXName: 'pxPlan',//培训高亮
      userCenterTab: 'usreInfo',
      activeTableList: [],// 活跃度的表格信息
      currentActivePage: 1,// 活跃度的当前页
      activeTableList_total: 0,// 活跃度的总条目数
      pageSize: 10,// 活跃度每页值
      publishWDList: [],// 我发布的文档
      currentWDActivePage: 1,//我发布的文档当前页
      pageWDSize: 7,// 我发布的每页的值
      activeWDList_total: 0,// 我发布的总条目数
      getPLList: [],// 我得评论的列表
      currentPLActivePage: 1,//我评论的文档当前页
      pagePLSize: 7,//我评论的每页的值
      activePLList_total: 0,// 我的评论总条数
      getSCList: [],// 我的收藏的列表
      currentWDSCActivePage: 1,//我的收藏的当前页
      pageWDSCSize: 7,//我的收藏的每页的值
      activeWdSCList_total: 0,//我的收藏的总条数
      // 个人信息部分
      // apiURL:'index.php/user/internal/upload',// 上线的头像地址
      //apiURL:'api/index.php/'+'user/internal/upload',//头像的地址
      // uploadActionUrl:'api/index.php/'+'user/internal/upload',//上传附件的地址
      uploadActionUrl: '/index.php/' + 'user/internal/upload',//上传附件的地址
      uploadData: {dataType: "0", oldFilePath: ""},
      is_pwd: 0,// 是否设置用户登录密码
      newYZMInput: '',//新建验证码
      newYZM: '',// 新的密码
      pxList: [],// 我的培训的列表
      currentPXActivePage: 1,//当前页显示的page
      pagePXSize: 7,//默认的我的培训显示的每页的条数
      activePXList_total: 0,// 我的培训的总的条目数
      teskName: 'teskDetailList',//任务列表的详情
      pxDetailShow: true,// 培训列表
      lessonList: [],//课程列表的数组
      liveList: [],// 直播的列表的数组
      lessonPageSize: 5,// 每页显示的课程
      currentLessonActivePage: 1,// 当前的页码
      activeLessonList_total: 0,// 总共的课程数
      activeLiveList_total: 0,//总共的直播数
      currentLiveActivePage: 1,//当前直播页
      livePageSize: 5,// 每页显示的直播数
      userInfo: {
        name: '未设置，请联系管理员设置',
        userPic: '',// 用户上传的图片
        phone: '',//用户号码
        account: '未设置，请联系管理员设置',//用户账号
        password: '',//用户密码
        sex: '未设置，请联系管理员设置',//显示的性别
        group: '未设置，请联系管理员设置',//所属分组
        duty: '未设置，请联系管理员设置',//用户职务
      },//个人中心信息的数组
      fileList: [],//个人信息
      ksList: [],//考试列表
      show: true,
      pwdshow: true,
      count: '',
      count1: '',
      timer: null,
      timer1: null,
      currentKSActivePage: 1,// 当前页
      ksPageSize: 10,//每页的考试数量
      ksList_total: 0,//总共的考试条数
      // newYZMPhone:'',//发送验证码的手机号
      ruleForm: {//手机号的验证规则
        newYZMPhone: '',
        newYZMPWD: ''
      },
      rules: {
        newYZMPhone: [
          {required: true, message: "请输入手机号码", trigger: "blur"},
          {min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur"},
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          },
        ],
        newYZMPWD: [
          {required: true, message: "请输入密码", trigger: "blur"},
        ]
      },
      teskDetail: {},//我的培训计划详情
      updatePhone: false,//发送修改手机号弹窗可见性
      active: 0,//我的活跃度
      pxDetailList: [],//我的培训的课程详情
      portrait: '',//用户头像
      name: '',//用户姓名
      jibie: '',//用户等级
      toTestDeatil: true,// 去用户考试列表
      ewCode: '',//二维码图片
      dialogVisible: false,//控制二维码的可见性
      activeLink: '',
      custom_fields: [],//用户自定义添加的数组
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    handleKSCurrentChange(val) {
      this.currentKSActivePage = val
      this.getTestList()
    },
    async getTestList() {//获取考试的列表
      const res1 = await this.$http.get('/index.php/internal/examination/user_examination_list', {page: this.currentKSActivePage})
      this.ksList = res1.data.data
      this.ksList_total = res1.data.total
    },
    async toTest(id) {// 去考试详情
      //  this.toTestDeatil=false //考试的详情
      //  this.testName='testdetail'
      const res1 = await this.$http.get(`/index.php/internal/examination/examination_qrcode?path=/pages/exam/examDetail?id=${id}`)
      this.ewCode = res1.data
      this.dialogVisible = true
    },
    toLiveDetail(id) {// 去直播的详情
      this.$router.push(`/live/liveList?id=${id}`)
    },
    toLessonDetail(id) {//我的课程去课程详情
      this.$router.push(`/lesson/lessonDetail?id=${id}`)
    },
    getOriginUserInfo() {
      // 返回的对象是promise
      this.$http.get('index.php/user/internal/info').then((res) => {
        this.portrait = res.data.portrait
        this.name = res.data.name
        this.jibie = res.data.jibie
        this.custom_fields = JSON.parse(res.data.custom_fields)
        console.log(this.custom_fields, '11111111111111111111111111')
      })
    },
    stillToStudy(id, tid, sign) {//去任务详情
      this.isCanToDeatil(id, tid, sign)
    },
    async isCanToDeatil(cid, tid, sign) {//去任务详情
      const res1 = await this.$http.get('index.php/user/internal/is_study', {content_id: cid, training_plan_id: tid})
      if (res1.data == 0) {
        this.$message.info('请按照顺序完成任务')
      } else {
        if (res1.code == 200) {
          if (sign == 'lore') {
            this.$router.push(`/lesson/lessonList?id=${cid}&training_plan_id=${tid}`)
          } else if (sign == 'serial') {
            this.$router.push(`/lesson/${cid}?training_plan_id=${tid}`)
          } else {
            this.toTest(cid)
          }
        } else {
          this.$message.error('请按顺序完成任务！')
        }
      }
    },
    async sureUploadPWD() {//点击确认修改密码
      if (this.ruleForm.newYZMPWD == '') {
        return;
      } else {
        const res1 = await this.$http.post('index.php/user/internal/update_info', {
          password: this.ruleForm.newYZMPWD,
          code: this.newYZMInput
        })
        if (res1.code == 200) {
          this.$message.success('修改密码成功！')
          this.getUserInfo()
        }
      }
    },
    async beforePhone() {//点击确认手机（之前）
      const res1 = await this.$http.post('index.php/user/internal/is_sms', {
        phone: this.userInfo.phone,
        code: this.newYZMInput
      })
      if (res1.code == 200) {
        this.newYZMInput = ''
        this.updatePhone = true
      } else {
        this.$message.error(res1.error)
      }
    },
    getBeforeCode(phone, type) {//点击发送手机号验证码（之前）
      if (type == 1) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.getYZCode(phone)
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      } else {
        const TIME_COUNT1 = 60;
        if (!this.timer1) {
          this.count1 = TIME_COUNT1;
          this.pwdshow = false;
          this.getYZCode(phone)
          this.timer1 = setInterval(() => {
            if (this.count1 > 0 && this.count1 <= TIME_COUNT1) {
              this.count1--;
            } else {
              this.pwdshow = true;
              clearInterval(this.timer1);
              this.timer1 = null;
            }
          }, 1000)
        }
      }

    },
    hidePopover() {// 当隐藏弹出框时
      this.ruleForm.newYZMPhone = ''
      this.ruleForm.newYZMPWD = ''
      this.newYZMInput = ''
      this.updatePhone = false
    },
    async toDeleteMP(id) {//点击删除我发布的文档
      const res1 = await this.$http.post('index.php/internal/knowledge_api/delDocument', {id: id})
      console.log(res1, '删除我发布的文档')
      this.getWendang()
    },
    async sureChangeUserInfo() {//确认修改保存信息
      console.log(this.userInfo.portrait, '头像')
      console.log(this.userInfo.phone, '手机')
      console.log(this.password, '密码')
      console.log(this.code, '验证码')
      const res1 = await this.$http.post('index.php/user/internal/update_info', {portrait: this.userInfo.portrait})
      if (res1.code == 200) {
        this.portrait = this.userInfo.portrait
        this.$emit("changePic", this.userInfo.portrait)
        //  location.reload();
      } else {
        this.$message.error(res1.error)
      }

    },
    async sureUploadPhone() {//确认修改手机号
      if (this.ruleForm.newYZMPhone == '') {
        return false;
      } else {
        const res1 = await this.$http.post('index.php/user/internal/update_info', {
          phone: this.ruleForm.newYZMPhone,
          code: this.newYZMInput
        })
        if (res1.code == 200) {
          this.$message.success('修改手机号成功！')
          this.getUserInfo()
        } else {
          this.$message.error(res1.error)
        }
      }
      this.updatePhone = false
    },
    async getYZCode(phone) {//获取验证码的操作
      const res1 = await this.$http.post('index.php/college/auth/send_code', {phone: phone})
      console.log(res1)
    },
    getCode() {// 获取二维码的倒计时效果
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.getYZCode()
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        } else {
          return;
        }
      })

    },
    async getUserInfo() {// 获取用户个人信息
      const res1 = await this.$http.get('index.php/user/internal/info')
      this.userInfo = res1.data
      if (res1.data.sex == 1) {
        return this.userInfo.sex = '男'
      } else if (res1.data.sex == 2) {
        return this.userInfo.sex = '女'
      } else {
        return this.userInfo.sex = '未知'
      }
    },
    successUpload(response) {// 文件成功上传的相应事件.
      this.file_id = response.data.id
      this.userInfo.portrait = response.data
    },
    handleFileChange() {
      // this.userInfo.portrait=file.response.data
    },
    handleBeforeUpload(file) {//用来对上传的图片进行约束
      const isImage = file.type.includes("image");
      if (!isImage) {
        this.$message.error("上传文件类型必须是图片!");
      }
      return isImage;
    },
    toMyCommentDetail(id) {// 查看我评论的文档
      this.toDetailDOC(id)
    },
    toMyPublishDetail(id) {// 编辑我发布的文档
      this.$router.push(`/knowledgeBase/document?id=${id}`)
    },
    toDocDetail(id) {//去我的文档的详情
      this.toDetailDOC(id)
    },
    async toDetailDOC(id) {
      this.$router.push(`/knowledgeBase/articleDetail?id=${id}`)
    },
    handleWDSCCurrentChange(val) {// 我的收藏的分页切换时
      this.currentWDSCActivePage = val
      this.getWDSC()
    },
    async getWDSC() {//获取我的收藏列表信息
      const res1 = await this.$http.get('index.php/user/internal/collect', {
        page: this.currentWDSCActivePage,
        pageSize: this.pageWDSCSize,
        type: 1
      })
      this.getSCList = res1.data.data
      this.activeWdSCList_total = res1.data.total
    },
    handlePLCurrentChange(val) {//评论分页切换时
      this.currentPLActivePage = val
      this.getPL()
    },
    async getPL() {// 获取评论列表
      const res1 = await this.$http.get('index.php/user/internal/problem', {
        page: this.currentPLActivePage,
        pageSize: this.pagePLSize
      })// 我评论的
      this.getPLList = res1.data.data
      this.activePLList_total = res1.data.total
    },
    handleWDeCurrentChange(val) {// 我发布的文档页码改变时
      this.currentWDActivePage = val
      this.getWendang()
    },
    async getWendang() {// 获取我发布的文档
      const res1 = await this.$http.get('index.php/user/internal/my_word', {
        pageNo: this.currentWDActivePage,
        pageSize: this.pageWDSize
      })
      this.activeWDList_total = res1.data.totalNum
      this.publishWDList = res1.data.data
    },
    handleActiveCurrentChange(val) {// 活跃度的页码改变时
      this.currentActivePage = val
      this.getActives()
    },
    async getActives() {//获取活跃度的信息
      const res3 = await this.$http.get('index.php/user/internal/active_log', {
        page: this.currentActivePage,
        pageSize: this.pageSize
      })// 活跃度的记录
      this.activeTableList_total = res3.data.data.total
      this.activeTableList = res3.data.data.data
      this.active = res3.data.active
    },
    handlePXCurrentChange(val) {// 我的培训页码改变时
      this.currentPXActivePage = val
      this.getPXList()
    },
    async getPXList() {// 获取我的培训内容详情
      const res1 = await this.$http.get('index.php/user/internal/my_training', {
        page: this.currentPXActivePage,
        pageSize: this.pagePXSize
      })
      this.pxList = res1.data.data
      this.activePXList_total = res1.data.total
    },
    getToPXDetail(id) {//去培训详情
      this.$router.push(`/userCenter/?traning_plan=${id}`)
      this.pxDetailShow = !this.pxDetailShow
      this.getpxDetailList(id)
    },
    handlePXItemClick() {
    },
    async getpxDetailList(id) {// 获取对应培训详情的内容
      const res1 = await this.$http.get('index.php/user/internal/training_info', {training_plan_id: id})
      this.teskDetail = res1.data.training
      this.pxDetailList = res1.data.list
    },
    handleLessonCurrentChange(val) {//当课程的页码改变时
      this.currentLessonActivePage = val
      this.getLessonList()
    },
    async getLessonList() {// 获取课程的列表
      const res1 = await this.$http.get('index.php/user/internal/learn_record', {
        type: 0,
        pageNo: this.currentLessonActivePage,
        pageSize: this.lessonPageSize
      })
      this.lessonList = res1.data.data
      this.activeLessonList_total = res1.data.totalNum
    },
    async getLiveList() {//获取直播的列表
      const res2 = await this.$http.get('index.php/user/internal/learn_record', {
        type: 1,
        pageNo: this.currentLiveActivePage,
        pageSize: this.livePageSize
      })
      this.liveList = res2.data.data
      this.activeLiveList_total = res2.data.totalNum
    },
    handleLiveCurrentChange(val) {//当直播的页码改变时
      this.currentLiveActivePage = val
      this.getLiveList()
    },
    handleDocClick() {// 点击文档
    },
    handleLessonClick() {// 点击课程
    },
    userCenterTabClick() {// 点击个人信息
    },
    handleSCClick() {//点击我的收藏
    },
    handlePXClick() {//点击我的培训
    },
    handleKSClick() {//我的考试

    },
    handleAllTabChange() {
      this.pxDetailShow = false
    }
  },
  created() {
    this.getActives()
    this.getWendang()
    this.getPL()
    this.getWDSC()
    this.getPXList()
    this.getLessonList()
    this.getLiveList()
    this.getUserInfo()
    this.getOriginUserInfo()
    this.getTestList()
    this.headers.token = localStorageCache.fetch('token')
    this.activeLink = this.$route.query
    console.log(this.activeLink.active, '000000000000000000000000000')
    if (this.activeLink.active == undefined) {
      this.activeName1 = 'one'
      console.log(this.activeLink, '222222222222222222222222222222')
    } else {
      console.log(this.activeLink.active, '111111111111111111111111111')
      this.activeName1 = 'eight'
      this.userCenterTab = 'activeInfo'
      this.userCenterTab = this.$route.query.active
    }

  }

}
</script>

<style scoped>
.green {
  color: #3ab33a;
}

.el-icon-success {
  font-size: 20px;
  margin-top: 4px;
}

.traningItem span {
  position: absolute;
  left: 30px;
  font-size: 16px;
}

.traningItem {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
}

.password {
  color: #ccc
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}

::v-deep .el-dialog__body {
  padding: 0;
}

.ewCode {
  position: fixed;
  z-index: 1000;
  left: 50%;
  width: 250px;
  height: 250px;
  transform: translateX(-50%);
}

.el-form-item {
  margin-bottom: 0px;
}

/* i{margin-left:10px;} */
.doc .el-tab-pane {
  position: relative;
}

.el-popover .el-button {
  margin-left: 142px;
  height: 34px;
  background-color: #5173f5;
  border-color: #fff;
  line-height: 8px;
}

.el-popover .el-input {
  margin-bottom: 20px;
}

.tipsName {
  margin: 20px 10px;
}

.yzmBox {
  color: #333;
  cursor: pointer;
  height: 60%;
  margin-top: 11%;
  line-height: 23px;
  border-left: 1px solid #ccc;
  position: relative;
  width: 84px;
  padding-left: 10px;
}

::v-deep .el-popover {
  padding: 20px;
}

::v-deep .el-upload {
  position: absolute;
  left: 250px;
  top: 30px;
}

::v-deep .ant-upload-list-item {
  display: none;
}

.stillStudyBtn .button {
  color: #fff;
}

.el-pagination {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
}

.activeNum {
  font-size: 20px;
}

.allBox {
  background-color: #f7f7f7;
}

.object-cover {
  border-radius: 4px;
  display: block;
  width: 200px;
  height: 116px;
  width: 200px;
  height: 116px;
}

.nocontent {
  margin-left: 50%;
  transform: translateX(-50%);
}

.doc li {
  position: relative;
  width: 100%;
  padding: 50px 0px;
  border-bottom: 1px solid #edf0f4;
}

.lesson li {
  padding: 15px 0px;
}

.R-10 {
  margin-right: 10PX;
}

.usercenter_main {
  align-items: center;
  display: flex;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  margin-bottom: 30px;
}

.ss-user-progress {
  width: 470px;
}

.ss-user-item:last-child {
  border-bottom: none
}

::v-deep .ant-empty-image img {
  margin: 0 auto
}

.personalInfo {
  width: 216px;
  height: 900px;
  background-color: white;
  border-top: 4px solid #5173f5;
  margin-top: 25px;
}

.user_avatar {
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-left: 70px;
  margin-right: 70px;
  margin-top: 30px;
  text-align: center;
}

::v-deep .ant-avatar > img {
  height: 109%;
}

.user_pic {
  color: #000;
  border-radius: 50%;
  width: 80px;
  height: 80px;
}

.user_level, .user_name {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  width: 100%;
  margin-top: 15px;
  text-align: center;
}

.study {
  font-weight: bold;
  font-size: 16px;
  color: #000;
  margin-top: 45px;
  padding-left: 45px;
  width: 125px;
  background-image: url(../assets/images/zs.png);
  background-repeat: no-repeat;
  background-position: 20px 4px;
}

::v-deep.el-tabs--left .el-tabs__item.is-left {
  text-align: right;
  font-size: 14px;
  /* color: #666e7a; */
}

.mine {
  font-weight: bold;
  margin-top: 15px;
  font-size: 16px;
  color: #000;
  padding-left: 60px;
  width: 125px;
  background-image: url(../assets/images/my.png);
  background-repeat: no-repeat;
  background-position: 20px 3px;
}

.px {
  font-weight: bold;
  margin-top: 15px;
  font-size: 16px;
  color: #000;
  padding-left: 60px;
  width: 125px;
  background-image: url(../assets/images/px.png);
  background-repeat: no-repeat;
  background-position: 20px 4px;
}

.bigTab ::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.bigTab ::v-deep .el-tabs__active-bar {
  background-color: transparent;
}

.bigTab ::v-deep .el-tabs__content {
  position: absolute;
  top: 25px;
  left: 230px;
  width: 960px;
  height: 900px;
  background-color: #fff;
  padding: 25px 20px;
}

.bigTab ::v-deep el-tabs__nav-scroll {
  height: 140px;
}

.bigTab ::v-deep .el-tabs__item {
  padding: 0px 60px;
}

.bigTab ::v-deep .el-tabs--left {
  margin-top: 10px;
}

.bigTab ::v-deep .el-tabs__item {
  padding: 0px 10px;
}

.notallowed {
  cursor: not-allowed;
}

.kong {
  margin-RIGHT: 16px;
}

.doc ::v-deep .el-tabs__active-bar {
  background-color: #409EFF;
}

.doc ::v-deep .el-tabs__nav-wrap::after {
  background-color: rgba(225, 225, 225);
}

.doc ::v-deep .el-tabs__content {
  width: 100%;
  top: 55px;
  left: 0px;
}

.lookBtn {
  width: 80px;
  position: absolute;
  right: 30px;
  top: 35px;
  padding: 8px 15px;
  border-radius: 4px;
}

.lookBtn1 {
  width: 80px;
  position: absolute;
  right: 30px;
  top: 23px;
  padding: 8px 11px;
  border-radius: 4px;
}

.tl {
  position: absolute;
  left: 100px;
  top: 60px;
  color: #7e7d7d;
}

.title {
  position: absolute;
  left: 100px;
  top: 20px;
  font-size: 16px;
  color: #333;
}

.typeImg {
  position: absolute;
  top: 13px;
  left: 15px;
  width: 67px;
}

.typeImg1 {
  position: absolute;
  width: 100px;
  border-radius: 2px;
  top: 10px;
}

.title1 {
  position: absolute;
  left: 116px;
  top: 15px;
  font-size: 16px;
  color: #333;
}

.t2 {
  position: absolute;
  left: 115px;
  top: 50px;
  color: #7e7d7d;
}

.looknum {
  margin-left: 30px;
}

.user_info {
  margin-top: 30px;
}

::v-deep #tab-3, ::v-deep #tab-7 {
  margin-top: 15px;
}

.description {
  text-align: center;
}

.stillStudyBtn {
  top: 40px;
  right: 15px;
  position: absolute;
}

.button {
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  width: 104px;
  height: 36px;
  box-shadow: 0px 2px 25px rgba(116, 143, 247, 0.5);
  width: 108px;
  border-radius: 18px;
  text-align: center;
  line-height: 36px;
  background-color: #748ff7;
  border: none;
  cursor: pointer;
  position: relative;
  /*box-shadow: 0 2px 25px rgba(116 ，143, 247, 0.5);*/
  outline: 0;
  transition: transform ease-in 0.1s, background-color ease-in 0.1s, box-shadow ease-in 0.25s;
}

.button::before {
  position: absolute;
  content: '';
  left: -2em;
  right: -2em;
  top: -2em;
  bottom: -2em;
  pointer-events: none;
  transition: ease-in-out .5s;
  background-repeat: no-repeat;
  background-image: radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), /*  */ radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%), radial-gradient(circle, #748ff7 20%, transparent 20%);
  background-size: 10% 10%, 20% 20%, 15% 15%, 20% 20%, 18% 18%, 10% 10%, 15% 15%, 10% 10%, 18% 18%, 15% 15%, 20% 20%, 18% 18%, 20% 20%, 15% 15%, 10% 10%, 20% 20%;
  background-position: 18% 40%, 20% 31%, 30% 30%, 40% 30%, 50% 30%, 57% 30%, 65% 30%, 80% 32%, 15% 60%, 83% 60%, 18% 70%, 25% 70%, 41% 70%, 50% 70%, 64% 70%, 80% 71%;
  animation: bubbles ease-in-out .75s forwards;
}

.button:active {
  transform: scale(0.95);
  background-color: #748ff7;
  box-shadow: 0 2px 25px rgba(116, 143, 247, 0.5);
}

.button:active::before {
  animation: none;
  background-size: 0;
}

.user_pagination {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

@keyframes bubbles {
  0% {
    background-position: 18% 40%, 20% 31%, 30% 30%, 40% 30%, 50% 30%, 57% 30%, 65% 30%, 80% 32%, 15% 60%,
    83% 60%, 18% 70%, 25% 70%, 41% 70%, 50% 70%, 64% 70%, 80% 71%;
  }
  50% {
    background-position: 10% 44%, 0% 20%, 15% 5%, 30% 0%, 42% 0%, 62% -2%, 75% 0%, 95% -2%, 0% 80%,
    95% 55%, 7% 100%, 24% 100%, 41% 100%, 55% 95%, 68% 96%, 95% 100%;
  }
  100% {
    background-position: 5% 44%, -5% 20%, 7% 5%, 23% 0%, 37% 0, 58% -2%, 80% 0%, 100% -2%, -5% 80%,
    100% 55%, 2% 100%, 23% 100%, 42% 100%, 60% 95%, 70% 96%, 100% 100%;
    background-size: 0% 0%;
  }
}

.button1 {
  border-radius: 18px;
  color: #ece9e9;
  box-shadow: 0px 2px 20px rgba(1, 1, 1, .05);
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  width: 104px;
  height: 36px;
  box-shadow: 0px 2px 25px rgba(232, 233, 235, 0.5);
  width: 108px;
  border-radius: 18px;
  text-align: center;
  line-height: 36px;
  background-color: #c8c9cc;
  border: none;
  cursor: pointer;
  position: relative;
  /*box-shadow: 0 2px 25px rgba(116,143, 247, 0.5);*/
  outline: 0;
  transition: transform ease-in 0.1s, background-color ease-in 0.1s, box-shadow ease-in 0.25s;
}

.button1:active {
  transform: scale(0.95);
  background-color: #c8c9cc;
  box-shadow: 0 2px 25px rgba(232, 233, 235, 0.5);
}

.button1:active::before {
  animation: none;
  background-size: 0;
}

@keyframes bubbles1 {
  0% {
    background-position: 18% 40%, 20% 31%, 30% 30%, 40% 30%, 50% 30%, 57% 30%, 65% 30%, 80% 32%, 15% 60%,
    83% 60%, 18% 70%, 25% 70%, 41% 70%, 50% 70%, 64% 70%, 80% 71%;
  }
  50% {
    background-position: 10% 44%, 0% 20%, 15% 5%, 30% 0%, 42% 0%, 62% -2%, 75% 0%, 95% -2%, 0% 80%,
    95% 55%, 7% 100%, 24% 100%, 41% 100%, 55% 95%, 68% 96%, 95% 100%;
  }
  100% {
    background-position: 5% 44%, -5% 20%, 7% 5%, 23% 0%, 37% 0, 58% -2%, 80% 0%, 100% -2%, -5% 80%,
    100% 55%, 2% 100%, 23% 100%, 42% 100%, 60% 95%, 70% 96%, 100% 100%;
    background-size: 0% 0%;
  }
}

.myLessonName {
  color: rgb(51, 51, 51);
  position: absolute; /* right: 0px; */
  left: 240px;
  top: 22px;
  font-size: 20px;
  font-weight: bold;
}

.hasStudy {
  position: absolute;
  top: 74px;
  left: 240px;
  font-size: 13px;
}

.test li {
  border-bottom: 1px solid #edf0f4;
  margin-top: 10px;
  padding: 43px 0px;
}

.test ::v-deep .el-tabs__content {
  position: absolute;
  left: 0px;
  top: 40px;
}

.test .title {
  left: 24px;
}

.test .tl {
  left: 24px;
}

.test .tl .time {
  margin-left: 0px !important;
}

.test .time {
  font-size: 14px;
}

.test .lookBtn {
  background-color: #748ff7;
  color: #fff;
}

.score {
  margin-right: 100px;
  position: absolute;
  right: 30px;
  top: 28px;
  font-size: 16px;
}

.userCount ::v-deep .el-tabs__content {
  margin-top: 25px;
}

.userCount ::v-deep .el-tab-pane {
  margin-top: 20px;
}

.userCount li {
  padding: 10px;
  border-bottom: none;
}

.yhxx_chang_pic {
  position: absolute;
  left: 233px;
  bottom: 0px;
}

.yhxx_img {
  margin-top: 0px !important;
  margin-left: 0px !important;
  position: absolute;
  left: 150px;
  width: 60px;
  height: 60px;
  line-height: 50px;
  font-size: 18px;
  position: absolute;
  top: 0px;
}

.yhxx_name {
  width: 120px;
  height: 60px;
  color: #333333;
  font-weight: bold;
  position: absolute;
  background-color: #f3f5f7;
  text-align: center;
  line-height: 60px;
}

.yhxx_div {
  position: relative;
  height: 60px;
}

.yhxx_input {
  position: absolute;
  left: 130px;
  border-bottom: 1px solid #ccc;
  width: 760px;
  height: 60px;
}

.input_nicheng1 {
  padding-left: 15px;
  margin-left: 10px;
  height: 100%;
  width: 94%;
  line-height: 67px;
}

.yhxx_sure {
  transform: translateX(-50%);
  background-color: #fff;
  width: 140px;
  height: 40px;
  position: absolute;
  left: 50%;
  margin-top: 25px;
  border-color: #5173f5;
  color: #5173f5
}

.yhxx_sure:hover {
  color: #fff;
  transform: scale(1.05) translateX(-50%);
  transition: all .5s;
  background-color: #5173f5;
}

.user_Upload .ant-btn {
  position: absolute;
  left: 250px;
  top: 30px;
}

.fixed {
  color: #5173f5;
  position: absolute;
  top: 20px;
  right: 0px;
}

.px_typeImg {
  width: 120px;
  height: 80px;
}

.px_title {
  left: 160px;
}

.px_t1 {
  left: 160px;
}

.finished {
  color: #ccc;
  border-color: #ccc;
}

/* .isOnTesk{color: #5173f5;border-color: #5173f5;} */
.still_btn {
  height: 20px;
  line-height: 0px;
  margin-left: 20px;
}

.tesk {
  position: relative;
  margin-top: 20px;
}

.tesk img {
  position: absolute;
  top: 2px;
  left: 0px;
}

.tesk span {
  position: absolute;
  left: 20px;
}

.name {
  position: relative;
  font-size: 16px;
}

/* .list .el-tabs{margin-top:50px;} */
.list .el-steps {
  margin-top: 10px;
}

.yhxx_div ::v-deep .el-upload-list__item-name {
  display: none;
}

.yhxx_div ::v-deep .el-upload-list__item .el-icon-upload-success {
  display: none;
}

.count {
  color: #ccc;
}

.lookBtn {
  width: 80px;
  position: absolute;
  right: 110px;
  top: 35px;
  padding: 8px 15px;
  border-radius: 4px;
}

.delMPBtn {
  position: absolute;
  right: 20px;
  top: 35px;
  padding: 8px 15px;
  width: 80px;
}

.access {
  font-size: 12px;
  width: 120px;
  color: #1890ff;
  margin-left: 20px;
  border-radius: 3px;
  border: 1px solid #ccc;
  padding: 3px 5px;
  border-color: #1890ff;
}

.tabChild ::v-deep .el-tabs__content {
  width: 100%;
  top: 95px !important;
  left: 0;
}

.tabChild ::v-deep .el-tabs__header {
  position: absolute;
  top: 70px;
  width: 100%;
}

.el-timeline li {
  padding: 10px !important;
  border-bottom: none !important;
}

.wcBtn button {
  height: 30px;
  line-height: 6px;
  width: 90px;
}

::v-deep .el-timeline-item__content {
  display: flex;
  justify-content: space-between;
}

.stillBtn {
  color: #1890ff;
  border: 1px solid #1890ff;
}

::v-deep .el-form-item__error {
  top: 70%;
}

.el-button--primary.is-plain {
  background: rgba(116, 143, 247);
  border: rgba(116, 143, 247);
  color: #fff;
}

.button a {
  color: #fff !important;
}

.ksDetail ::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}

.ksDetail ::v-deep .el-tabs__content {
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: rgba(247, 247, 247);
}

.testDetail ::v-deep .el-tabs__content {
  left: 0px;
  position: absolute;
  top: 0px;
  background: rgba(247, 247, 247);
  padding: 0px;
}

/deep/ .el-dialog {
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.kongImg {
  text-align: center;
  margin-top: 40%;
  transform: translateY(-70%);
}

.kongImg img {
  width: 500px;
}

.test0 {
  overflow-y: scroll;
  height: 630px;
  width: 102%;
}

.test0-5::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 2px;
}

.test0-5::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: rgba(193, 193, 193);
  background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
  );
}

.test0-5::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(247, 247, 247);
  background: #ededed;
  border-radius: 10px;
}

::v-deep .el-dialog {
  width: 330px;
  position: absolute;
  top: 35%;
  height: 340px;
  left: 50%;
  background: #fff;
  transform: translate(-50%);
  margin-top: 0 !important;
}

.toSM {
  font-weight: bold;
  position: absolute;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
}
</style>